import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import useWindowSize from '../../hooks/useWindowSize'
import { Line } from 'rc-progress'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons'
import Confetti from 'react-confetti'
import { ClipLoader, PulseLoader } from 'react-spinners'
import { SET_PERSONALISE_MCQ_ANSWER, SET_PERSONALISE_USER_RANK } from '../../redux/actions/types'
import Logo from '../OnboardingRevampPage/Logo'
import { ColorRing } from 'react-loader-spinner'
import { fetchAnalysis } from '../../redux/actions/personaliseCourse'
import { Mixpanel } from '../../config/Mixpanel'
import Constants from '../../common/constants'
import './index.css'
import { useSearchParams } from "react-router-dom";

export const images = [
    'https://assets.learntube.ai/files/Learntube/Group_8427-modified.png?updatedAt=1688826368148', 
    'https://assets.learntube.ai/files/Learntube/Group_8427__1_-modified.png?updatedAt=1688826500580', 
    'https://assets.learntube.ai/files/Learntube/Group_8427__2_-modified.png?updatedAt=1688826589078', 
    'https://assets.learntube.ai/files/Learntube/Group_8427__3_-modified.png?updatedAt=1688826667584', 
    'https://assets.learntube.ai/files/Learntube/Group_8427__4_-modified.png?updatedAt=1688826759338'
]

export const questionsTag = [
    '86% people who completed this quiz got hired',
    '93% users loved their feedback & course',
    '93% users loved their feedback & course',
    '88% quiz takers felt more confident on completing',
    '70% Users Got Hired Who Completed This Quiz'
]

const Questions = () => {

    const email = useSelector(store => store?.profileDetails?.email)    
    const questions = useSelector(state => state.personaliseCourse?.questions?.questionaire)
    const skillName = useSelector(state => state.personaliseCourse?.skill_name)
    const name = useSelector(state => state.profileDetails?.name)
    const analysisData = useSelector(state => state.personaliseCourse?.analysis)
    const answers = useSelector(state => state.personaliseCourse?.answers)
    const onboardingData = useSelector(state => state.personaliseCourse?.onboardingData)
    const uuid = useSelector(state => state.personaliseCourse?.UUID)
    const customisedSkill = useSelector(state => state.personaliseCourse?.customSkillSelected)
    
    const {width, height} = useWindowSize()
    const { id } = useParams()
    const questionId = parseInt(id)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const [step, setStep] = useState(questionId)
    const [showConfetti, setShowConfetti] = useState(false)
    const [showLoader, setShowLoader] = useState(false)
    const [seconds1, setSeconds1] = useState(9)
    const [optionA, setOptionA] = useState(false)
    const [optionB, setOptionB] = useState(false)
    const [optionC, setOptionC] = useState(false)
    const [optionD, setOptionD] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_QUESTION, {
            distinct_id: email
        })
        if (Object.keys(analysisData)?.length > 0){
            navigate('/onboarding/analysis')
        } else if (questions?.length === 0) {
            toast.error('Please enter the details')
            navigate('/')
        }
    },[])

    useEffect(() => {
        if (step === 8){
            let score = 0
            const mcq = []
            const correctAnswers = []
            const binaryAnswerList = []
            for (let i = 0; i < 7; i++){
                if (answers[i] === questions?.[i]?.answer){
                    binaryAnswerList.push(1)
                    score+=14.28
                } else {
                    binaryAnswerList.push(0)
                }
                correctAnswers.push(questions?.[i][`option_${questions?.[i]?.answer}`]);
                mcq.push(questions?.[i].question)
            }
            dispatch(fetchAnalysis(uuid, skillName, mcq, correctAnswers, binaryAnswerList, Math.floor(score)))
            dispatch({ type: SET_PERSONALISE_USER_RANK, payload: Math.floor(Math.random() * (731 - 100 + 1)) + 100 })
            setTimeout(()=> setStep(9), 1500)
        }
    }, [step])

    useEffect(() => {
        if (step >= 9){
            if (seconds1 === 7){
                setShowLoader(true)
            }
            if (seconds1 === 6){
                setShowLoader(false)
                setStep(10)
            }
            if (seconds1 === 4){
                setShowLoader(true)
            }
            if (seconds1 === 3){
                setShowLoader(false)
                setStep(11)
            }if (seconds1 === 1){
                setShowLoader(true)
            }
            if (seconds1 === 0){
                if(Object.keys(analysisData)?.length > 0){
                    navigate('/onboarding/analysis')
                } else {
                    setSeconds1(9)
                    setStep(9)
                }
            }
        }
    },[step, seconds1])

    useEffect(() => {
        if (step >= 9) {
            const timer = setInterval(() => {
                if (seconds1 === 0) {
                clearInterval(timer);
            } else {
                setSeconds1(prevSeconds => prevSeconds - 1);
            }
            }, 1000);
            return () => {
                clearInterval(timer);
            };
        }
    }, [seconds1, step])

    const handleBack = () => {
        if (questionId <= 7){
            setStep(prev => prev - 1)
            navigate(`/onboarding/questions/${questionId - 1}`)
        }
    }

    const handleAnswer = (string) => {
        if (string === 'a'){
            setOptionA(true)
            setTimeout(()=>{setOptionA(false)}, 100)
        } else if (string === 'b'){
            setOptionB(true)
            setTimeout(()=>{setOptionB(false)}, 100)
        }else if (string === 'c'){
            setOptionC(true)
            setTimeout(()=>{setOptionC(false)}, 100)
        }else if (string === 'd'){
            setOptionD(true)
            setTimeout(()=>{setOptionD(false)}, 100)
        }
        if (answers[questionId -1]){
            Mixpanel.track(
                questionId === 1 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_1_REANSWERED : 
                questionId === 2 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_2_REANSWERED : 
                questionId === 3 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_3_REANSWERED : 
                questionId === 4 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_4_REANSWERED : 
                questionId === 5 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_5_REANSWERED : 
                questionId === 6 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_6_REANSWERED : 
                Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_7_REANSWERED)
            dispatch({type: SET_PERSONALISE_MCQ_ANSWER, payload: { answer: string, index: questionId - 1}})
        } else {
            Mixpanel.track(
                questionId === 1 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_1: 
                questionId === 2 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_2: 
                questionId === 3 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_3: 
                questionId === 4 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_4: 
                questionId === 5 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_5: 
                questionId === 6 ? Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_6: 
                Constants.Mixpanel.PERSONALISE_PAGE_QUESTION_7)
            dispatch({type: SET_PERSONALISE_MCQ_ANSWER, payload: { answer: string, index: questionId - 1}})
        }
        if (questionId < 7) {
            setStep(prev => prev + 1)
            setTimeout(() => navigate(`/onboarding/questions/${questionId + 1}`), 300)
        } else {
            setShowConfetti(true)
            setTimeout(() => setStep(prev => prev + 1),3500)
        }
    }
    
    const handleSkip = () => {
        if (customisedSkill){
            if(searchParams.get("course")){
                navigate(`/popular-course/${searchParams?.get("course")}`);
              }
              else{
         navigate('/courses')}
              
        }else{
            navigate(`/${onboardingData.course_slug}/${onboardingData.skill_slug}/${onboardingData.mskill_slug}/${onboardingData.id}`)
        }
    }
    
    return (
        <div className=''>
        {step <= 7 && <div className='parent-radial-gradient-background'>
            {questionId !== 1 ? <div className='bg-white absolute cursor-pointer z-50 w-6 h-6 top-8 left-8 flex justify-center items-center rounded-full' onClick={handleBack}>
                <FontAwesomeIcon icon={faArrowLeft} className='text-lg text-black font-semibold'/>
            </div> : null}
            <div className='absolute z-50 top-5 md:top-8 right-6 md:right-10 cursor-pointer' onClick={() => {
                Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_SKIP)
                handleSkip()}}
            >
                <p className='text-[#1CA571] underline font-semibold'>Skip</p>
            </div>
            <div  className='text-white md:w-1/2 md:mx-auto min-h-screen p-4 md:p-6 flex flex-col'>
                <Logo/>
                <div className='relative text-white mt-10 md:mt-14'>
                    <Line percent={answers?.length === 7 ? '100':  questionId === 1 ? '5' : questionId === 7 ? '93'  : `${(questionId) * 90/7}`} strokeWidth={`${width > 768 ? '1' : '3'}`} trailWidth={`${width > 768 ? '1' : '3'}`} strokeColor="#7FC241" trailColor="#D9D9D9" />
                    <div className={`absolute -top-9 md:-top-[38px] ${answers?.length === 7 ? 'left-[95%] md:left-[97%]' : questionId === 1 ? 'left-[5%]' : questionId === 2 ? 'left-[23%]' : questionId === 3 ? 'left-[35%] md:left-[37%]' : questionId === 4 ? 'left-[49%]' : questionId === 5 ? 'left-[61%]': questionId === 6 ? 'left-[72%] md:left-[75%]':'left-[89%] md:left-[90%]'}`}>
                        <p className=' opacity-90 text-base mb-1'>{questionId}/7</p>
                        <div>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Vector.svg?updatedAt=1685338311398" alt="start icon" />
                        </div>
                    </div>
                    <p className='text-sm tracking-wider mt-3'>{questionsTag[questionId <= 2 ? 0 : questionId <= 4 ? 1 : questionId <= 5 ? 2 : questionId <= 6 ? 3 : 4]}</p>
                </div>
                <div className='flex-1 h-full mt-10 md:mt-6'>
                    <h2 className='text-xl font-semibold leading-7 mb-4'>{questions?.[id-1]?.question}</h2>
                    <div className={`cursor-pointer w-full h-auto py-2 flex justify-between items-center rounded-xl ${optionA ? 'border-2 border-[#7FC241]' : ''} ${answers?.[questionId - 1] === 'a' ? 'bg-[#517EAA] border-2 border-[#7FC241]' : ''} bg-secondary_background mb-2 `} onClick={() => handleAnswer('a')}>
                        <div className='flex items-center justify-start'>
                            <div>
                                <div className='w-[1rem] h-[1rem] mx-3 border-2 border-[#7FC241] rounded-full flex justify-center items-center'>
                                    <div className={`w-[8px] h-[8px] rounded-full ${answers?.[questionId - 1] === 'a' ? 'bg-[#7FC241]' : ''}`}>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xl font-medium pr-1'>{questions?.[questionId - 1]?.option_a}</p>
                        </div>
                    </div>
                    <div className={`cursor-pointer w-full h-auto py-2 flex justify-between items-center rounded-xl ${optionB ? 'border-2 border-[#7FC241]' : ''}  ${answers?.[questionId - 1] === 'b' ? 'bg-[#517EAA]' : ''} bg-secondary_background mb-2`} onClick={() => handleAnswer('b')}>
                        <div className='flex items-center justify-start'>
                            <div>
                                <div className='w-[1rem] h-[1rem] mx-3 border-2 border-[#7FC241] rounded-full flex justify-center items-center'>
                                    <div className={`w-[8px] h-[8px] rounded-full ${answers?.[questionId - 1] === 'b' ? 'bg-[#7FC241]' : ''}`}>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xl font-medium pr-1'>{questions?.[questionId - 1]?.option_b}</p>
                        </div>
                    </div>
                    <div className={`cursor-pointer w-full h-auto py-2 flex justify-between items-center rounded-xl ${optionC ? 'border-2 border-[#7FC241]' : ''}  ${answers?.[questionId - 1] === 'c' ? 'bg-[#517EAA]' : ''} bg-secondary_background mb-2`} onClick={() => handleAnswer('c')}>
                        <div className='flex items-center justify-start'>
                            <div>
                                <div className='w-[1rem] h-[1rem] mx-3 border-2 border-[#7FC241] rounded-full flex justify-center items-center'>
                                    <div className={`w-[8px] h-[8px] rounded-full ${answers?.[questionId - 1] === 'c' ? 'bg-[#7FC241]' : ''}`}>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xl font-medium pr-1'>{questions?.[questionId - 1]?.option_c}</p>
                        </div>
                    </div>
                    <div className={`cursor-pointer w-full h-auto py-2 flex justify-between items-center rounded-xl ${optionD ? 'border-2 border-[#7FC241]' : ''}  ${answers?.[questionId - 1] === 'd' ? 'bg-[#517EAA]' : ''} bg-secondary_background`} onClick={() => handleAnswer('d')}>
                        <div className='flex items-center justify-start'>
                            <div>
                                <div className='w-[1rem] h-[1rem] mx-3 border-2 border-[#7FC241] rounded-full flex justify-center items-center'>
                                    <div className={`w-[8px] h-[8px] rounded-full ${answers?.[questionId - 1] === 'd' ? 'bg-[#7FC241]' : ''}`}>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xl font-medium pr-1'>{questions?.[questionId - 1]?.option_d}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>}
        <Confetti 
            width={width} 
            height={height} 
            numberOfPieces={showConfetti ? 1000 : 0} 
            recycle={false}
            confettiSource={{x: 0, y: 0, w: width, h: height}}
        />
        {step === 8 && <div className='parent-radial-gradient-background'>
            <div className='flex flex-col p-4 min-h-screen items-center text-center md:w-3/4 md:mx-auto text-white'>
                <Logo/>
                <div className='flex flex-1 flex-col items-center justify-center'>
                <ColorRing
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="blocks-loading"
                    wrapperStyle={{}}
                    wrapperClass="blocks-wrapper"
                    colors={['#7FC241', '#7FC241', '#7FC241', '#7FC241', '#7FC241']}
                />
                    <p className='text-2xl'>{name}, Analysing your answers</p>
                </div>
            </div>
            </div>
        }
        {step === 9 && <div className='parent-radial-gradient-background'>
            <div className='flex flex-col p-4 min-h-screen items-center text-center md:w-3/4 md:mx-auto text-white'>
                <Logo/>
                <div className='mt-6'>
                    <ClipLoader color='#7FC241' size={30} />
                    <div className='flex'>
                        {showLoader && <FontAwesomeIcon icon={faCheck} className='text-[#00C838] text-lg mr-2'/>}
                        <p className='text-sm'>Grading your answers{showLoader ? '!' : ''}</p>
                        {!showLoader && <PulseLoader color='#fff' size={2} className='mt-3'/>}
                    </div>
                </div>
                <div className='flex-1 flex flex-col justify-center'>
                    <h2 className='text-[32px] mx-auto md:w-3/4 leading-9'>LearnTube Users Have<span className='font-bold text-[#00C1FF]'>  78% Chance </span> of Getting Hired By MAANG Companies</h2>
                    <div className='w-[90%] md:w-[50%] mx-auto mt-9'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/image_445.png?updatedAt=1685347228780" alt="company images" className='w-full'/>
                    </div>
                </div>
            </div>
        </div>}
        {step === 10 && <div className='parent-radial-gradient-background'>
            <div className='md:w-3/4 h-screen p-4 flex-1 md:mx-auto flex flex-col items-center text-center text-white'>
                <Logo/>
                <div className=''>
                    <ClipLoader color='#7FC241' size={30} />
                    <div className='flex'>
                        {showLoader && <FontAwesomeIcon icon={faCheck} className='text-[#00C838] text-lg mr-2'/>}
                        <p className='text-sm'>Processing your performance data{showLoader ? '!' : ''}</p>
                        {!showLoader && <PulseLoader color='#fff' size={3} className='mt-3'/>}
                    </div>
                </div>
                <div className='flex-1 flex flex-col justify-center'>
                    <h2 className='text-[32px] leading-9'>Our Users See A<span className='font-bold text-[#00C1FF]'> 88% Chance </span> of Getting Hired By Indian Unicorn Companies</h2>
                    <div className='w-[90%] md:w-1/2 mx-auto mt-7'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/image_446.png?updatedAt=1685348127605" alt="company image" className='w-full'/>
                    </div>
                </div>
            </div>
        </div>}
        {step === 11  && <div className='parent-radial-gradient-background'>
            <div className='md:w-3/4 p-4 flex-1 mx-auto h-screen flex flex-col items-center text-center text-white'>
                <Logo/>
                <div className=''>
                    <ClipLoader color='#7FC241' size={30} />
                    <div className='flex'>
                        {showLoader && <FontAwesomeIcon icon={faCheck} className='text-[#00C838] text-lg mr-2'/>}
                        <p className='text-sm'>Generating feedback for you{showLoader ? '!' : ''}</p>
                        {!showLoader && <PulseLoader color='#fff' size={2} className='mt-3'/>}
                    </div>
                </div>
                <div className='flex-1 flex flex-col justify-center'>
                    <h2 className='text-[32px] leading-9'>Our Learners Report<span className='font-bold text-[#00C1FF]'> 43% Higher Salaries </span>Than Average</h2>
                    <div className='mx-auto md:w-[40%] md:mt-3'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8343.png?updatedAt=1686908015108" alt="package images" className='w-full'/>
                    </div>
                </div>
            </div>
        </div>}
    </div>)
}

export default Questions